import React from 'react';
import Icon from '../../../components/AppIcon';

const ProgressTracker = ({ completed = 0, total = 12 }) => {
  const progressPercentage = Math.round((completed / total) * 100);
  
  const getProgressLevel = () => {
    if (completed === 0) return { level: 'Débutant', color: 'text-muted-foreground' };
    if (completed < total * 0.3) return { level: 'Novice', color: 'text-blue-500' };
    if (completed < total * 0.6) return { level: 'Intermédiaire', color: 'text-warning' };
    if (completed < total * 0.9) return { level: 'Avancé', color: 'text-success' };
    return { level: 'Expert', color: 'text-error' };
  };

  const progressLevel = getProgressLevel();

  return (
    <div className="bg-card border border-border rounded-lg p-4">
      <div className="flex items-center space-x-3">
        <div className="flex-shrink-0">
          <div className="w-10 h-10 bg-accent/10 rounded-lg flex items-center justify-center">
            <Icon name="Trophy" size={20} className="text-accent" />
          </div>
        </div>
        
        <div className="flex-1 min-w-0">
          <div className="flex items-center justify-between mb-2">
            <div>
              <div className="text-sm font-medium text-card-foreground">Progression</div>
              <div className={`text-xs ${progressLevel?.color}`}>{progressLevel?.level}</div>
            </div>
            <div className="text-xs text-muted-foreground">
              {completed}/{total}
            </div>
          </div>
          
          <div className="w-full bg-muted rounded-full h-2">
            <div 
              className="bg-accent h-2 rounded-full transition-all duration-300"
              style={{ width: `${progressPercentage}%` }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProgressTracker;